import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingOverlayService {
    private visible = new BehaviorSubject<boolean>(false);
    readonly isVisible$ = this.visible.asObservable();

    show(): void { this.visible.next(true); }
    hide(): void { this.visible.next(false); }
}
